<template>
    <div class="modal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" style="width:90%;max-width:90%;">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title pull-left">Consulta do dia {{ selectedEvent.dds_date | brDate }}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <button v-if="enableDelete" class="btn btn-danger" @click="deleteEvent(selectedEvent.dds_date)">
                            <i class="fa fa-trash"></i> Deletar
                        </button>
                        <hr>
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Título</th>
                                    <th>Unidade</th>
                                    <th>Área</th>
                                    <th>Turno</th>
                                    <th style="width:110px">Horário</th>
                                    <th>Status</th>
                                    <th>Participantes</th>
                                    <th>Terceiros</th>
                                    <th>Total de participantes</th>
                                    <th>% Participação</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(event, index) in selectedEvents" :key="event.id">
                                    <td v-if="!event.editing">{{ (event.simplified_theme) ? event.simplified_theme.title
                        : '-' }}</td>
                                    <td v-if="event.editing">
                                        <v-select :options="themes" label="title" :reduce="theme => theme.id"
                                            :clearable="false" v-model="event.newTheme.id"></v-select>
                                    </td>
                                    <td>{{ event.branch ? event.branch.name : '-' }}
                                    </td>
                                    <td>{{ (event.teams_shifts && event.teams_shifts.team.name) ?
                        event.teams_shifts.team.name :
                        event.team.name ? event.team.name : '-' }}
                                    </td>
                                    <td>{{ (event.teams_shifts && event.teams_shifts.shift.name) ?
                        event.teams_shifts.shift.name : '-' }}</td>
                                    <td v-if="!event.editing">{{ new Date(event.dds_date).toLocaleTimeString() }}</td>
                                    <td v-if="event.editing">
                                        <input type="time" v-model="event.newTime" class="form-control" />
                                    </td>
                                    <td>{{ (event.status) ? event.status.name : '-' }}</td>
                                    <td>{{ (event.quantity_person) ? event.quantity_person : '-' }}</td>
                                    <td>{{ (event.participants_external) ? event.participants_external : '-' }}</td>
                                    <td>{{ (event.team) ? event.total_participants : '-' }}</td>
                                    <td v-if="event.status_id == 3">
                                        {{ event.total_participants !== 0 ? ((event.quantity_person /
                        event.total_participants * 100).toFixed(2) + '%') : 'N/A' }}


                                    </td>
                                    <td v-else>N/A</td>
                                    <td>

                                        <!-- <a v-show="event.status_id != 3" data-toggle="tooltip" title="Editar"
                                            class="btn btn-warning fa fa-pencil" @click="edit(event)"></a>-->

                                        <a class="btn btn-info fa fa-eye" v-bind:href="'/events/view/' + event.id"
                                            target="_blank"></a>
                                        <a v-show="event.status_id != 3" data-toggle="tooltip" data-dismiss="modal"
                                            title="Deletar" class="btn btn-danger fa fa-trash"
                                            @click="destroy(event.id, index)"></a>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success pull-left" data-dismiss="modal" aria-label="Close">
                        Fechar
                    </button>
                    <!--  <button @click="save" type="button" class="btn" style="background-color: green; color:white"
                        aria-label="Close">
                        Salvar
                    </button>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    props: ["selectedEvents", "selectedEvent", "enableDelete", "themes"],
    methods: {
        save() {
            let successMessageDisplayed = false;

            this.selectedEvents.forEach(event => {
                event.theme_id = event.newTheme.id
                event.theme.title = this.themes.find(theme => theme.id == event.newTheme.id).title
                event.dds_date = event.dds_date.substr(0, 11) + event.newTime + ':00'
                let form = new FormData();

                form.append("theme_id", event.newTheme.id);
                form.append("dds_date", event.dds_date);
                form.append("emotional_status", event.emotional_status);

                const self = this;
                const api = self.$store.getters.api + "events/" + event.id;

                self.$http
                    .post(api, form)
                    .then((response) => {
                        this.$parent.getEvents();
                        event.editing = false;
                        this.$forceUpdate();
                        if (!successMessageDisplayed) { // Verifica se a mensagem já foi exibida
                            self.$message(null, "Evento editado com sucesso", "success");
                            successMessageDisplayed = true; // Marca que a mensagem foi exibida
                        }

                        $('#detailModal').modal('hide'); // Fecha o modal com jQuery
                    })
                    .catch((error) => {
                        self.$error("Não foi possível editar o evento");
                    });
            })
        },
        edit(event) {
            if (event.editing) {
                event.editing = false
                this.$forceUpdate();
                return
            }
            event.editing = true
            this.$forceUpdate();
        },
        deleteEvent(date) {
            const self = this;
            const api = self.$store.getters.api + "events/delete";

            swal({
                title: "Deseja deletar o registro?",
                text: "Somente será deletado os eventos Programados",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger"
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm"
                    }
                }
            })
                .then(value => {
                    switch (value) {
                        case "cancel":
                            swal("Cancelado", "O registro não foi excluido!", "info");
                            break;

                        case "confirm":
                            self.$http
                                .post(api, {
                                    dds_date: date
                                })
                                .then(response => {
                                    self.$message(null, "Eventos deletados com sucesso", "success");
                                })
                                .then(() => {
                                    $("#detailModal").modal("toggle");
                                    self.$emit("deleteEvents");
                                });
                            break;
                    }
                });
        },
        destroy(id, index) {
            const self = this;

            swal({
                title: "Deseja deletar o registro?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, deletar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger"
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm"
                    }
                }
            }).then(value => {
                switch (value) {
                    case "cancel":
                        swal("Cancelado", "O registro não foi excluido!", "info");
                        break;
                    case "confirm":
                        self.$http
                            .delete(self.$store.getters.api + "events/" + id, {
                                id: id
                            })
                            .then(response => {
                                self.selectedEvents.splice(index, 1);
                                this.$parent.getEvents();
                                swal("Sucesso", "Registro excluído com sucesso!", "success");
                            })
                            .catch(errors => {
                                let error = errors.response ? errors.response.data : errors;
                                swal("Erro", error, "error");
                            });
                        break;
                }
            });
        },

    },
    filters: {
        brDate(date) {
            if (date) {
                return (date.substr(8, 2) + "/" + date.substr(5, 2) + "/" + date.substr(0, 4));
            }
            return '';
        }
    }
}
</script>

<style scoped>
.scroll-modal {
    max-height: 480px;
    overflow: overlay;
}

@media screen and (max-width: 767px) {
    .scroll-modal {
        max-height: unset;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Schedule/DetailModal.vue